import { AuthPermission } from '@shared/stores/auth'
import { ExtractRouteNames } from '@shared/types/RouteNames'
import { metaDataAuthGuard } from '@shared/guards/auth'
import LogOut from '@/views/LogOut.vue'
import AboutToken from '@/views/AboutToken.vue'
import { RouteRecordRaw } from 'vue-router'
import { routes as analyticsRoutes } from '@analytics/router/routes'
import { routes as subscriptionsRoutes } from '@subscriptions/router/routes'
import { routes as supportRoutes } from '@support/router/routes'
import { routes as tradePortalRoutes } from '@trade-portal/router/routes'
import { routes as targetsRoutes } from '@targets/router/routes'

// components
const SilentAuth = () => import(/* webpackChunkName: "SilentAuth" */ '@/views/SilentAuth.vue')
const SkynamoHome = () => import(/* webpackChunkName: "SkynamoHome" */ '@/views/SkynamoHome.vue')
const SwitchInstances = () => import('@/views/SwitchInstances.vue')
const UnauthorizedView = () => import('@/views/UnauthorizedView.vue')

declare module 'vue-router' {
  interface RouteMeta {
    requiredScopes?: AuthPermission[]
    fallbackRedirect?: string
  }
}

const showcaseRoutes: RouteRecordRaw[] = process.env.ENV !== 'production'
  ? [(await import('@design-system-showcase/router/routes')).routes]
  : []

export const baseRoutes = [
  {
    path: '/silent-auth',
    name: 'SilentAuth',
    component: SilentAuth,
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: UnauthorizedView,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    beforeEnter: metaDataAuthGuard,
    redirect: to => {
      return {
        name: 'Home',
        state: {
          redirectFrom: JSON.stringify(to),
        },
      }
    },
  },
  {
    path: '/switch-instances',
    name: 'SwitchInstances',
    beforeEnter: metaDataAuthGuard,
    component: SwitchInstances,
  },
  {
    path: '/about-token',
    name: 'AboutToken',
    component: AboutToken,
  },
  {
    path: '/logout',
    name: 'LogOut',
    component: LogOut,
  },
  {
    path: '/',
    name: 'Home',
    beforeEnter: metaDataAuthGuard,
    component: SkynamoHome,
    children: [analyticsRoutes, subscriptionsRoutes, supportRoutes, tradePortalRoutes, targetsRoutes, ...showcaseRoutes],
  },
] as const satisfies RouteRecordRaw[]

export type BaseRouteNames = ExtractRouteNames<typeof baseRoutes[number]>